var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrizes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6a.31.31 0 01.161.046c.05.03.088.077.113.14l.687 1.706 1.768.162a.309.309 0 01.162.07c.04.036.07.082.09.139a.3.3 0 01-.085.334l-1.34 1.215.404 1.806a.277.277 0 01-.013.185.342.342 0 01-.106.135.301.301 0 01-.154.061.272.272 0 01-.17-.044L12 10.996l-1.517.96a.272.272 0 01-.17.043.301.301 0 01-.154-.06.342.342 0 01-.106-.136.277.277 0 01-.013-.185l.403-1.806-1.34-1.215a.305.305 0 01-.084-.334.347.347 0 01.09-.139.309.309 0 01.162-.07l1.768-.162.687-1.705a.275.275 0 01.113-.141A.31.31 0 0112 6z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2a7 7 0 015.066 11.827v7.11l-.01.149c-.099.68-.86 1.06-1.463.731l-.127-.08-2.866-2.151a1.001 1.001 0 00-1.2 0l-2.868 2.15-.126.081a1.001 1.001 0 01-1.463-.731l-.01-.15v-7.11A7 7 0 0112 2zM8.433 19.936l2.066-1.55.17-.117a2.501 2.501 0 012.66 0l.17.117 2.067 1.55v-4.913A6.966 6.966 0 0112 16a6.965 6.965 0 01-3.567-.979v4.915zM12 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11z",
    fill: "currentColor"
  })));
}
SvgPrizes.displayName = 'Prizes';
export default SvgPrizes;